{
  "title": "NEON NOVA",
  "rulesheet": [
    "Charge the Star Core and shoot the scoop to start Star Systems.",
    "Lock balls in the Wormhole to start Nova Multiball.",
    "Complete six systems and start Nova Multiball. Shoot Event Horizon for Supernova."
  ],
  "modeGoals": {
    "asteroidRun": "Complete the I-O-N target bank twice.",
    "ionStorm": "Make 500 Ion Spinner hits.",
    "gravityWell": "Shoot the Event Horizon scoop three times.",
    "pulsarFrenzy": "Make 40 total hits across the three Pulsar bumpers."
  },
  "rulesNotes": [
    "Each of the six Star Systems gets one attempt per game. A timed-out or unfinished system cannot be retried that game.",
    "Complete all six systems and play Nova Multiball to qualify Supernova."
  ],
  "lighting": {
    "version": 1,
    "palette": {
      "idle": "#FFE9B5",
      "active": "#27DDE8",
      "hit": "#F3FFFF",
      "award": "#FFC857"
    },
    "modes": {
      "solarFlare": "#FF7850",
      "asteroidRun": "#AF9CFF",
      "ionStorm": "#F651CE",
      "gravityWell": "#65DAF0",
      "pulsarFrenzy": "#FA75A9",
      "eventHorizon": "#BA80FC",
      "novaMultiball": "#27DDE8",
      "supernova": "#FFDF82",
      "bigBang": "#F7E3CB"
    },
    "cues": {
      "jackpot": "jackpot",
      "superJackpot": "jackpot",
      "novaMultiball": "multiball",
      "supernova": "multiball",
      "bigBang": "jackpot",
      "starCore": "bank",
      "combo": "combo",
      "laneComplete": "bank"
    },
    "paths": {
      "wormholeRamp": "wormholeArrow",
      "wormholeRail": "wormholeArrow",
      "solarWindRamp": "solarWindArrow",
      "solarWindRail": "solarWindArrow"
    }
  }
}
